export default __webpack_public_path__ + "fafe53a8aed99dd9ac00696f0f6d5a4e.svg";